(function () {
  // Fade ONLY the main (first/active) product image in once it's decoded, so
  // it never pops in half-painted. Everything else — other slides, thumbnails —
  // renders natively for maximum snappiness. CSS pre-hides just the main image
  // with a short keyframe failsafe, so slow loads fall back to normal
  // progressive rendering instead of a long blank box.
  function init() {
    var mains = document.querySelectorAll(
      '.product__media-list .product__media-item:first-child .product__media img'
    );

    mains.forEach(function (img) {
      var markLoaded = function () {
        img.dataset.loaded = 'true';
      };
      var finish = function () {
        if (typeof img.decode === 'function') {
          img.decode().then(markLoaded).catch(markLoaded);
        } else {
          markLoaded();
        }
      };
      if (img.complete && img.naturalWidth > 0) {
        finish();
        return;
      }
      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', markLoaded, { once: true });
      if (img.complete && img.naturalWidth > 0) finish();
    });

    // Fully load the remaining gallery slides in the background once the page
    // (including the main image) has finished loading: flip the real <img>
    // elements from lazy to eager so they fetch AND decode now, making
    // thumbnail clicks instant instead of loading on demand.
    var warm = function () {
      document
        .querySelectorAll('.product__media-list .product__media img[loading="lazy"]')
        .forEach(function (img) {
          img.loading = 'eager';
          var markWarm = function () {
            img.dataset.loaded = 'true';
          };
          img.addEventListener(
            'load',
            function () {
              if (typeof img.decode === 'function') {
                img.decode().then(markWarm).catch(markWarm);
              } else {
                markWarm();
              }
            },
            { once: true }
          );
          if (img.complete && img.naturalWidth > 0) {
            if (typeof img.decode === 'function') {
              img.decode().then(markWarm).catch(markWarm);
            } else {
              markWarm();
            }
          }
        });
    };
    var scheduleWarm = function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warm, { timeout: 2000 });
      } else {
        setTimeout(warm, 300);
      }
    };
    if (document.readyState === 'complete') {
      scheduleWarm();
    } else {
      window.addEventListener('load', scheduleWarm, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
